// Create this file to store your API base URL
// const API_BASE_URL = "http://34.206.193.218:5010";
const API_BASE_URL = "https://api.ownerbuilderssoftware.com"; 

export default API_BASE_URL;
